<template>
    <div class="af-app af-forgot-password">
        <ForgotPassword />
    </div>
</template>

<script>
    import Cookie from '@/services/cookie';
    import ForgotPassword from '@/apps/forgot-password/001/components/ForgotPassword';

    export default {
        name: 'App',

        components: {
            ForgotPassword,
        },

        created() {
            if (Cookie.getToken()) {
                window.location.href = '/user-dashboard';
            }
        },
    };
</script>
